import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Text from '../Text/Text';

import { calcPercent, isData } from 'utils/common';

import classes from './ProgressBar.module.scss';

const ProgressBar = ({
  is,
  of,
  text,
  progressClass,
  positionCenter = false
}) => {
  const val = isData(is) ? is : 0;
  const from = isData(of) ? of : 0;

  const getProgressValue = () => (from ? `${calcPercent(val, from)}%` : '0%');

  const progressValueStyle = {
    width: getProgressValue()
  };

  return (
    <div className={cn(classes.wrap, positionCenter && classes.wrap_center)}>
      <Text weight="b" size={2}>
        {text ? (
          <Text weight="b" className={classes.action} size={6}>
            {text}
          </Text>
        ) : (
          <>
            {val}
            <Text className={classes.tooMember} size={2}>
              {' '}
              / {from}
            </Text>{' '}
          </>
        )}
      </Text>

      <div className={cn(classes.progress, progressClass)}>
        <div style={progressValueStyle} className={classes.progressBar}></div>
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  is: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  of: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.string]),
  progressClass: PropTypes.string,
  positionCenter: PropTypes.bool
};

export default ProgressBar;
